export default "__VITE_ASSET__BPiEChCJ__"